import React from 'react';
import CompanySearch from '../components/CompanySearch';
import usePageMeta from '../hooks/usePageMeta';

function Company() {
  usePageMeta({
    title: 'Company Profile',
    description: 'View company cybersecurity profile details and risk indicators on Risqly.',
  });

  return <CompanySearch />;
}

export default Company;
